module.exports = __webpack_public_path__ + "static/media/User.180fc576.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Support/images/User.svg
 ** module id = 1321
 ** module chunks = 0
 **/